const { scores, weights } = require('../config')
const createSemesters = require('./semesters')
const _ = require('morphable')

module.exports = createYears

function createYears(initYears=[]) {
  const state = _({
      years: [],
      currentGPA: 0,
      currentCredits: 0,
      newYear (id, name, semesters) {
        id = id || (Math.random()).toString(36).slice(-5)
        name = name || `Year ${state.years.length+1}`
        const year = createSemesters(semesters)
        Object.assign(year, { id, name, remove: () => {
          if (state.years.length == 1) {
            state.newYear(null, 'Year 1')
          }
          rm(state.years, id)
        }})
        state.years.push(year)
      },
      get currentPoints () {
        return state.currentGPA * state.currentCredits
      },
      get weightedPoints () {
        return state.years.reduce((prev, next) => prev + next.weightedPoints, state.currentPoints)
      },
      get unweightedPoints () {
        return state.years.reduce((prev, next) => prev + next.weightedPoints, state.currentPoints)
      },
      get credits () {
        return state.years.reduce((prev, next) => prev + next.credits, state.currentCredits)
      },
      get gpa () {
        return state.weightedPoints / state.credits
      },
      get unweighted () {
        return state.unweightedPoints / state.credits
      }
  })

  initYears.forEach(({ id, name, semesters }) => state.newYear(id, name, semesters))

  return state
}

function rm (arr, id) {
  arr.splice(arr.map(item => item.id).indexOf(id), 1)
}

// function focusOnNewYear () {
//   var courses = document.getElementsByClassName('course-name')
//   var input = courses[courses.length-1].getElementsByTagName('input')[0]
//   input.focus()
// }
